export enum AuthProvidersEnum {
  EMAIL_PASSWORD = 'email-password',
  SOCIAL = 'social',
}
